/* ============================================================
   MONTCLAIR PARIS — ACL interactions
   Slider de coleções · scroll reveal · quick-add (cart AJAX Dawn)
   ============================================================ */
(function () {
  'use strict';

  /* ---------------- Collection slider ---------------- */
  function visibleCount() {
    if (window.innerWidth <= 480) return 1;
    if (window.innerWidth <= 768) return 2;
    return 3;
  }

  function initSlider(root) {
    const track = root.querySelector('.acl-coll-track');
    const prev = root.querySelector('.acl-coll-arrow.prev');
    const next = root.querySelector('.acl-coll-arrow.next');
    if (!track) return;
    let idx = 0;

    function slideW() {
      const s = track.querySelector('.acl-coll-slide');
      return s ? s.offsetWidth : 0;
    }
    function update() {
      const total = track.querySelectorAll('.acl-coll-slide').length;
      const vis = visibleCount();
      idx = Math.max(0, Math.min(idx, total - vis));
      track.style.transform = 'translateX(-' + idx * slideW() + 'px)';
      if (prev) prev.style.opacity = idx === 0 ? '0.35' : '1';
      if (next) next.style.opacity = idx >= total - vis ? '0.35' : '1';
    }
    if (prev) prev.addEventListener('click', function () { idx -= 1; update(); });
    if (next) next.addEventListener('click', function () { idx += 1; update(); });
    window.addEventListener('resize', function () { idx = 0; update(); });
    update();
  }

  /* ---------------- Scroll reveal ---------------- */
  // Varre elementos que ja passaram do topo da viewport. Necessario porque o
  // IntersectionObserver NAO dispara em saltos instantaneos (ancora, tecla End,
  // scroll muito rapido): o elemento vai de "abaixo" para "acima" sem intersectar
  // e ficaria invisivel para sempre.
  function revealSweep() {
    var pendentes = document.querySelectorAll('.acl-reveal:not(.in)');
    if (!pendentes.length) return;
    var h = window.innerHeight;
    pendentes.forEach(function (el) {
      if (el.getBoundingClientRect().top < h) el.classList.add('in');
    });
  }

  function initReveal() {
    const els = document.querySelectorAll('.acl-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // revela ao entrar na tela OU se ja passou por cima dela
        if (e.isIntersecting || e.boundingClientRect.top < 0) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.06 });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (i % 10) * 50 + 'ms';
      io.observe(el);
    });
  }

  /* ---------------- Cart drawer (lazy) ---------------- */
  var CD_ID = 'acl-cart-drawer';
  var cdLoading = false;

  function cdMount() { return document.getElementById('acl-cd-mount'); }
  function cdPanel() { return document.getElementById('acl-cd'); }

  function cdSyncCount() {
    var panel = cdPanel();
    var badge = document.querySelector('.acl-cart-count');
    if (!panel || !badge) return;
    var n = parseInt(panel.getAttribute('data-count') || '0', 10);
    badge.textContent = n;
    badge.style.display = n > 0 ? '' : 'none';
  }

  function cdSet(open) {
    var panel = cdPanel();
    var bg = document.querySelector('.acl-cd-bg');
    if (!panel) return;
    panel.classList.toggle('on', open);
    if (bg) bg.classList.toggle('on', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) cpPrewarm();   // adianta o link do checkout enquanto o cliente olha o carrinho
  }

  function cdInject(html, openAfter) {
    var mount = cdMount();
    if (!mount || !html) return false;
    mount.innerHTML = html;
    cdSyncCount();
    if (openAfter) requestAnimationFrame(function () { cdSet(true); });
    return true;
  }

  function cdApply(data, openAfter) {
    if (data && data.sections && data.sections[CD_ID]) return cdInject(data.sections[CD_ID], openAfter);
    return false;
  }

  // Abre: se ainda nao carregou o conteudo, busca sob demanda
  function cdOpen() {
    var mount = cdMount();
    if (!mount) return;
    if (mount.children.length) { cdSet(true); return; }
    if (cdLoading) return;
    cdLoading = true;
    fetch(window.location.pathname + '?section_id=' + CD_ID, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { cdLoading = false; cdInject(html, true); })
      .catch(function () { cdLoading = false; window.location = (window.routes && window.routes.cart_url) || '/cart'; });
  }

  /* ---------------- Quick add ---------------- */
  // Envia uma variante ao carrinho e ja pede o HTML do drawer na mesma ida.
  function addVariant(id) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ id: Number(id), quantity: 1, sections: [CD_ID], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adicionando…';

    addVariant(id)
      .then(function (response) {
        if (response.status) {
          btn.textContent = 'Indisponível';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
          return;
        }
        cpInvalidate();   // item novo: o link do checkout precisa ser refeito
        if (!cdApply(response, true)) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
        btn.textContent = '✓ Adicionado';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400);
      })
      .catch(function () { btn.textContent = original; btn.disabled = false; });
  }

  /* ---------------- Folha de tamanhos (botao "+" do card) ---------------- */
  var sheetEl = null;
  var sheetBg = null;
  var sheetLast = null; // devolve o foco ao "+" que abriu

  function sheetBuild() {
    if (sheetEl) return;
    sheetBg = document.createElement('div');
    sheetBg.className = 'acl acl-sheet-bg';
    sheetBg.setAttribute('data-acl-sheet-close', '');

    sheetEl = document.createElement('div');
    sheetEl.className = 'acl acl-sheet';
    sheetEl.setAttribute('role', 'dialog');
    sheetEl.setAttribute('aria-modal', 'true');
    sheetEl.innerHTML =
      '<button type="button" class="acl-sheet-grip" data-acl-sheet-close aria-label="Fechar"></button>' +
      '<p class="acl-sheet-title"></p>' +
      '<div class="acl-sheet-sizes"></div>';

    document.body.appendChild(sheetBg);
    document.body.appendChild(sheetEl);
  }

  function sheetSet(open) {
    if (!sheetEl) return;
    sheetEl.classList.toggle('on', open);
    sheetBg.classList.toggle('on', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (!open && sheetLast) { sheetLast.focus(); sheetLast = null; }
  }

  function sheetOpen(plus) {
    var card = plus.closest('.acl-pcard');
    var data = card && card.querySelector('[data-acl-variants]');
    if (!data) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    sheetBuild();
    sheetLast = plus;

    var nome = data.getAttribute('data-title') || '';
    sheetEl.setAttribute('aria-label', 'Escolha o tamanho — ' + nome);
    sheetEl.querySelector('.acl-sheet-title').textContent = nome;

    var box = sheetEl.querySelector('.acl-sheet-sizes');
    box.innerHTML = '';
    variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'acl-sheet-size' + (v.a ? '' : ' acl-sheet-size--out');
      b.textContent = v.t;
      if (v.a) {
        b.setAttribute('data-acl-sheet-add', '');
        b.setAttribute('data-variant-id', v.id);
      } else {
        b.disabled = true;
        b.title = 'Esgotado';
      }
      box.appendChild(b);
    });

    sheetSet(true);
    var first = box.querySelector('button:not(:disabled)');
    if (first) first.focus();
  }

  function sheetAdd(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    var box = btn.parentNode;
    box.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    btn.classList.add('is-loading');

    addVariant(id)
      .then(function (response) {
        btn.classList.remove('is-loading');
        if (response.status) {
          btn.classList.add('acl-sheet-size--out');
          btn.title = 'Indisponível';
          box.querySelectorAll('button:not(.acl-sheet-size--out)').forEach(function (b) { b.disabled = false; });
          return;
        }
        sheetSet(false);
        if (!cdApply(response, true)) window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        box.querySelectorAll('button:not(.acl-sheet-size--out)').forEach(function (b) { b.disabled = false; });
      });
  }

  /* ---------------- Motor de carrinho (atualizacao otimista) ---------------- */
  var BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function money(cents) { return BRL.format(cents / 100).replace(/\u00a0/g, ' '); }

  var cartQueue = Promise.resolve();

  function cartViews() { return document.querySelectorAll('[data-acl-cart-view]'); }

  function rowsOf(view) { return Array.prototype.slice.call(view.querySelectorAll('[data-cart-line]')); }

  function sumOf(view) {
    return rowsOf(view).reduce(function (t, r) {
      var unit = parseInt(r.getAttribute('data-unit') || '0', 10);
      var q = parseInt((r.querySelector('[data-cart-qty]') || {}).textContent || '0', 10);
      return t + unit * q;
    }, 0);
  }

  function paintTotals(view, totalCents, itemCount) {
    var isPage = view.getAttribute('data-acl-cart-view') === 'page';

    var label = view.querySelector('[data-cart-count-label]');
    if (label) label.textContent = itemCount;

    view.querySelectorAll('[data-cart-subtotal], [data-cart-total]').forEach(function (e) { e.textContent = money(totalCents); });
    var pix = view.querySelector('[data-cart-pix]'); if (pix) pix.textContent = money(Math.round(totalCents * 0.95));
    var parc = view.querySelector('[data-cart-parc]'); if (parc) parc.textContent = money(Math.round(totalCents / 6));

    var ship = view.querySelector('[data-cart-ship]');
    var remaining = 0;
    if (ship) {
      var th = parseInt(ship.getAttribute('data-threshold') || '0', 10);
      remaining = th - totalCents;
      var fill = ship.querySelector('[data-cart-ship-fill]');
      if (fill) fill.style.width = (th > 0 ? Math.min(100, Math.round((totalCents * 100) / th)) : 0) + '%';
      var msg = ship.querySelector('[data-cart-ship-msg]');
      if (msg) msg.innerHTML = remaining > 0
        ? 'Faltam <strong>' + money(remaining) + '</strong> para <strong>frete grátis</strong>'
        : 'Você ganhou <strong>frete grátis</strong>';
    }
    var shipLabel = view.querySelector('[data-cart-shipping-label]');
    if (shipLabel) shipLabel.textContent = remaining > 0 ? 'calculado no checkout' : 'Grátis';

    var panel = document.getElementById('acl-cd');
    if (panel) panel.setAttribute('data-count', itemCount);
    cdSyncCount();
  }

  function reindex(view) {
    rowsOf(view).forEach(function (r, i) { r.setAttribute('data-cart-line', i + 1); });
  }

  // Reconcilia com a verdade do servidor
  function reconcile(cart) {
    cartViews().forEach(function (view) {
      rowsOf(view).forEach(function (row, i) {
        var it = cart.items[i];
        if (!it) { row.remove(); return; }
        row.setAttribute('data-unit', it.final_price);
        var q = row.querySelector('[data-cart-qty]'); if (q) q.textContent = it.quantity;
        var lp = row.querySelector('[data-cart-line-price]'); if (lp) lp.textContent = money(it.final_line_price);
      });
      reindex(view);
      paintTotals(view, cart.total_price, cart.item_count);
    });
    if (cart.item_count === 0) window.location.reload();
    cpInvalidate(); cpPrewarmSoon();   // carrinho mudou: refaz o link do checkout
  }

  function cartChange(btn) {
    var row = btn.closest('[data-cart-line]');
    if (!row) return;
    var view = btn.closest('[data-acl-cart-view]');
    var qtyEl = row.querySelector('[data-cart-qty]');
    var cur = parseInt(qtyEl ? qtyEl.textContent : '0', 10);
    var remove = btn.hasAttribute('data-remove');
    var step = parseInt(btn.getAttribute('data-step') || '0', 10);
    var next = remove ? 0 : cur + step;
    if (next < 0) return;

    var line = rowsOf(view).indexOf(row) + 1;
    var unit = parseInt(row.getAttribute('data-unit') || '0', 10);

    // 1) pinta na hora (0ms), sem cortina
    if (next === 0) { row.remove(); }
    else {
      if (qtyEl) qtyEl.textContent = next;
      var lp = row.querySelector('[data-cart-line-price]');
      if (lp) lp.textContent = money(unit * next);
    }
    reindex(view);
    paintTotals(view, sumOf(view), rowsOf(view).reduce(function (t, r) {
      return t + parseInt((r.querySelector('[data-cart-qty]') || {}).textContent || '0', 10);
    }, 0));

    // 2) confirma com o servidor em segundo plano (serializado)
    cartQueue = cartQueue.then(function () {
      return fetch((window.routes && window.routes.cart_change_url) || '/cart/change', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: next })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && cart.items) reconcile(cart); })
        .catch(function () { window.location.reload(); });
    });
  }

  /* ---------------- Carrossel de produtos ---------------- */
  // Rola exatamente uma "pagina" (a largura visivel do trilho) e liga/desliga
  // as setas nas pontas. O scroll-snap do CSS alinha o card.
  function pcarSync(rail) {
    const sec = rail.closest('[data-acl-pcar]');
    if (!sec) return;
    const prev = sec.querySelector('[data-pcar-prev]');
    const next = sec.querySelector('[data-pcar-next]');
    const max = rail.scrollWidth - rail.clientWidth;
    // Poucos produtos: nada a rolar, entao nem mostra as setas.
    sec.classList.toggle('acl-pcar--static', max <= 2);
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max - 2;
  }

  function initPcar() {
    document.querySelectorAll('[data-acl-pcar]').forEach(function (sec) {
      const rail = sec.querySelector('[data-pcar-rail]');
      if (!rail) return;
      // initPcar roda de novo quando os relacionados chegam: nao duplicar listeners.
      if (sec.dataset.pcarReady) { pcarSync(rail); return; }
      sec.dataset.pcarReady = '1';
      pcarSync(rail);
      let tick = false;
      rail.addEventListener('scroll', function () {
        if (tick) return;
        tick = true;
        requestAnimationFrame(function () { pcarSync(rail); tick = false; });
      }, { passive: true });
      window.addEventListener('resize', function () { pcarSync(rail); }, { passive: true });
    });
  }

  function pcarMove(btn, dir) {
    const sec = btn.closest('[data-acl-pcar]');
    const rail = sec && sec.querySelector('[data-pcar-rail]');
    if (!rail) return;
    rail.scrollBy({ left: dir * rail.clientWidth, behavior: 'smooth' });
  }

  /* ---------------- Produtos relacionados ---------------- */
  // O HTML vem da API de recomendacoes da Shopify. So busca quando a secao
  // chega perto da tela — na PDP quase ninguem rola ate o fim.
  function relFetch(el) {
    const url = el.getAttribute('data-url');
    if (!url) return;
    el.removeAttribute('data-url');

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const novo = doc.querySelector('[data-acl-rel]');
        // Sem recomendacoes: a secao some em vez de deixar um titulo orfao.
        if (!novo || !novo.innerHTML.trim()) { el.remove(); return; }
        el.innerHTML = novo.innerHTML;
        initPcar();
      })
      .catch(function () { el.remove(); });
  }

  function initRelated() {
    const els = document.querySelectorAll('[data-acl-rel][data-url]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(relFetch); return; }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        relFetch(e.target);
      });
    }, { rootMargin: '600px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Checkout: CartPanda com queda para a Shopify ----------------
     O CartPanda sequestra a página /cart, mas o nosso carrinho é uma gaveta e o
     botão envia direto para o checkout da Shopify. Aqui perguntamos ao CartPanda
     se ele está ativo; se estiver, vamos para o checkout dele. Se estiver
     inativo, fora do ar ou demorar, o cliente segue para a Shopify sem travar.
  ------------------------------------------------------------------------------ */
  var cpBusy = false;

  /* Prewarm: perguntamos ao CartPanda o link do checkout ANTES do clique
     (ao abrir a gaveta / carregar o carrinho / mudar itens). Assim o clique
     em "Finalizar" redireciona na hora, sem esperar as duas chamadas. */
  var cpCache = null;      // { url } quando pronto
  var cpWarming = false;
  var cpTimer = null;

  function cpReady() {
    var cfg = window.ACL_CARTPANDA || {};
    return cfg.enabled && cfg.endpoint && cfg.shop;
  }
  function cpInvalidate() { cpCache = null; }

  function cpPrewarm() {
    if (!cpReady() || cpCache || cpWarming) return;
    cpWarming = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) { cpWarming = false; return; }
        var cfg = window.ACL_CARTPANDA || {};
        return fetch(cfg.endpoint, {
          method: 'POST',
          body: JSON.stringify({ shop: cfg.shop, host_name: window.location.host, cart_payload: cart })
        }).then(function (r) { return r.json(); });
      })
      .then(function (resp) {
        cpWarming = false;
        if (resp && resp.active && resp.checkout_direct_url) cpCache = { url: resp.checkout_direct_url };
      })
      .catch(function () { cpWarming = false; });
  }
  function cpPrewarmSoon() { clearTimeout(cpTimer); cpTimer = setTimeout(cpPrewarm, 400); }

  function cpGo(btn, form) {
    var cfg = window.ACL_CARTPANDA || {};
    if (!cfg.enabled || !cfg.endpoint || !cfg.shop) return false;  // segue o fluxo normal
    if (cpBusy) return true;                                        // trava clique duplo
    cpBusy = true;

    var texto = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Processando…';

    // CAMINHO RÁPIDO: link do CartPanda já pré-carregado -> redireciona na hora.
    if (cpCache && cpCache.url) { window.location.href = cpCache.url; return true; }

    function shopify() {                 // queda segura: checkout da Shopify
      cpBusy = false;
      btn.disabled = false;
      btn.textContent = texto;
      if (form) {
        // form.submit() nao envia o name do botao; sem "checkout" a Shopify so
        // atualiza o carrinho. Repomos o campo na mao antes de enviar.
        if (!form.querySelector('input[name="checkout"]')) {
          var hid = document.createElement('input');
          hid.type = 'hidden';
          hid.name = 'checkout';
          hid.value = '';
          form.appendChild(hid);
        }
        form.submit();
      } else {
        window.location.href = '/checkout';
      }
    }

    // Timeout total generoso: o CartPanda fica atras do Cloudflare e pode
    // demorar em conexoes lentas. Timeout curto demais mandava o cliente pra
    // Shopify sem necessidade. So caimos pra Shopify depois de tentar de verdade.
    var finished = false;
    var attempts = 0;
    var maxAttempts = 2;
    var totalTimeout = cfg.timeout || 8000;
    var timer = setTimeout(function () {
      if (finished) return;
      finished = true;
      shopify();
    }, totalTimeout);

    function done(fn) {                 // garante uma unica saida
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      fn();
    }

    function attempt() {
      attempts++;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (finished) return;
          return fetch(cfg.endpoint, {
            method: 'POST',
            body: JSON.stringify({ shop: cfg.shop, host_name: window.location.host, cart_payload: cart })
          }).then(function (r) { return r.json(); });
        })
        .then(function (resp) {
          if (finished || resp === undefined) return;
          if (resp && resp.active && resp.checkout_direct_url) {
            done(function () { window.location.href = resp.checkout_direct_url; });  // checkout do CartPanda
            return;
          }
          done(shopify);                        // CartPanda respondeu inativo -> Shopify
        })
        .catch(function () {
          if (finished) return;
          if (attempts < maxAttempts) { attempt(); return; }   // falha transitoria -> tenta de novo
          done(shopify);                                       // sem sucesso -> Shopify
        });
    }
    attempt();

    return true;
  }

  /* ---------------- Vídeo da marca ---------------- */
  // `hidden` e propriedade de HTMLElement; em <svg> so o atributo funciona.
  function svgShow(el, show) {
    if (!el) return;
    if (show) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  // Comandos ao YouTube via postMessage (enablejsapi=1) — sem carregar script externo.
  function ytCmd(iframe, func, args) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: func, args: args || [] }), '*'
    );
  }

  function vidParts(sec) {
    return {
      video: sec.querySelector('video'),
      yt: sec.querySelector('[data-acl-vid-yt]')
    };
  }

  function vidToggle(btn) {
    var sec = btn.closest('[data-acl-vid]');
    if (!sec) return;
    var p = vidParts(sec);
    var playing = sec.dataset.playing !== '0';   // começa tocando
    playing = !playing;
    sec.dataset.playing = playing ? '1' : '0';

    if (p.video) { playing ? p.video.play().catch(function () {}) : p.video.pause(); }
    else { ytCmd(p.yt, playing ? 'playVideo' : 'pauseVideo'); }

    // SVG nao implementa a propriedade .hidden (so HTMLElement) -> usar o atributo
    svgShow(btn.querySelector('.ic-pause'), playing);
    svgShow(btn.querySelector('.ic-play'), !playing);
    btn.setAttribute('aria-label', playing ? 'Pausar vídeo' : 'Reproduzir vídeo');
  }

  function vidSound(btn) {
    var sec = btn.closest('[data-acl-vid]');
    if (!sec) return;
    var p = vidParts(sec);
    var muted = sec.dataset.muted !== '0';       // começa mudo
    muted = !muted;
    sec.dataset.muted = muted ? '1' : '0';

    if (p.video) { p.video.muted = muted; }
    else {
      ytCmd(p.yt, muted ? 'mute' : 'unMute');
      if (!muted) ytCmd(p.yt, 'setVolume', [70]);
    }

    svgShow(btn.querySelector('.ic-off'), muted);
    svgShow(btn.querySelector('.ic-on'), !muted);
    btn.setAttribute('aria-label', muted ? 'Ativar som' : 'Desativar som');
  }

  function initVideo() {
    var secs = document.querySelectorAll('[data-acl-vid]');
    if (!secs.length || !('IntersectionObserver' in window)) return;
    // Fora da tela, pausa (poupa bateria e dados). Não mexe se o cliente pausou.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var sec = e.target;
        if (sec.dataset.playing === '0') return;
        var p = vidParts(sec);
        if (p.video) { e.isIntersecting ? p.video.play().catch(function () {}) : p.video.pause(); }
        else { ytCmd(p.yt, e.isIntersecting ? 'playVideo' : 'pauseVideo'); }
      });
    }, { threshold: 0.15 });
    secs.forEach(function (s) { io.observe(s); });
  }

  /* ---------------- Barra de anúncios ---------------- */
  function initBar() {
    var bar = document.querySelector('[data-acl-bar]');
    if (!bar) return;
    var notice = bar.querySelector('[data-acl-bar-notice]');
    var rot = bar.querySelector('[data-acl-bar-rot]');

    var KEY = 'acl-annc-dismissed';
    var fechado = false;
    try { fechado = sessionStorage.getItem(KEY) === '1'; } catch (e) {}

    function girar() {
      if (!rot) return;
      rot.hidden = false;
      var msgs = rot.querySelectorAll('.acl-bar-msg');
      if (msgs.length < 2) return; // uma só: sem rotação
      var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduz) return; // acessibilidade: não fica trocando sozinho
      var secs = parseInt(rot.getAttribute('data-secs'), 10) || 4;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, secs * 1000);
    }

    if (notice && !fechado) {
      notice.hidden = false;              // aviso tem prioridade
    } else {
      girar();
    }

    if (notice) {
      bar.addEventListener('click', function (e) {
        if (!e.target.closest('[data-acl-bar-close]')) return;
        notice.hidden = true;
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
        girar();                          // ao fechar, começam as vantagens
      });
    }
  }

  /* ---------------- Busca instantânea ---------------- */
  var srchTimer = null;
  var srchSeq = 0; // ignora respostas que chegam fora de ordem

  function srchEl() { return document.getElementById('acl-srch'); }

  function srchOpen() {
    var el = srchEl();
    if (!el) return;
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var input = el.querySelector('[data-acl-search-input]');
    // foco depois da transicao (iOS so abre o teclado com foco pos-animacao)
    setTimeout(function () { if (input) input.focus(); }, 60);
  }

  function srchClose() {
    var el = srchEl();
    if (!el) return;
    el.classList.remove('on');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Precos do suggest.json vêm como string em reais ("199.00"), nao em centavos.
  function srchMoney(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return 'R$ ' + n.toFixed(2).replace('.', ',');
  }
  function esc(t) { return String(t).replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function srchRender(box, products, query) {
    if (!products.length) {
      box.innerHTML = '<p class="acl-srch-empty">Nada encontrado para "<strong>' +
        esc(query) + '</strong>". Tente outra palavra.</p>';
      return;
    }
    var cards = products.map(function (p) {
      var src = (p.featured_image && p.featured_image.url) || p.image;
      var img = src
        ? '<img src="' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy" width="64" height="80">'
        : '<span class="acl-srch-ph"></span>';
      var preco = srchMoney(p.price_min != null ? p.price_min : p.price);
      var cmp = parseFloat(p.compare_at_price_min || 0);
      var pmin = parseFloat(p.price_min != null ? p.price_min : p.price);
      var risco = (cmp > pmin) ? '<s>' + srchMoney(p.compare_at_price_min) + '</s>' : '';
      return '<a href="' + p.url + '" class="acl-srch-item">' +
        '<span class="acl-srch-thumb">' + img + '</span>' +
        '<span class="acl-srch-meta"><span class="acl-srch-name">' + esc(p.title) + '</span>' +
        '<span class="acl-srch-price">' + preco + ' ' + risco + '</span></span></a>';
    }).join('');
    var url = (window.routes && window.routes.search_url ? window.routes.search_url : '/search') +
      '?q=' + encodeURIComponent(query) + '&type=product';
    box.innerHTML = '<div class="acl-srch-grid">' + cards + '</div>' +
      '<a href="' + url + '" class="acl-srch-all">Ver todos os resultados de "' + esc(query) + '"</a>';
  }

  function srchQuery(query) {
    var el = srchEl();
    if (!el) return;
    var box = el.querySelector('[data-acl-search-results]');
    var hint = el.querySelector('[data-acl-search-hint]');
    var clear = el.querySelector('[data-acl-search-clear]');
    if (clear) clear.hidden = !query;

    if (!query || query.length < 2) {
      box.innerHTML = '';
      if (hint) hint.hidden = false;
      return;
    }
    if (hint) hint.hidden = true;

    var seq = ++srchSeq;
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var url = base + '.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    box.classList.add('is-loading');
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (seq !== srchSeq) return; // chegou uma busca mais nova
        box.classList.remove('is-loading');
        var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
        srchRender(box, prods, query);
      })
      .catch(function () {
        if (seq !== srchSeq) return;
        box.classList.remove('is-loading');
        box.innerHTML = '';
      });
  }

  function initSearch() {
    var el = srchEl();
    if (!el) return;
    var input = el.querySelector('[data-acl-search-input]');

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(srchTimer);
      srchTimer = setTimeout(function () { srchQuery(q); }, 180);
    });

    // clique nas buscas populares
    el.querySelectorAll('[data-acl-search-term]').forEach(function (t) {
      t.addEventListener('click', function () {
        input.value = t.textContent.trim();
        input.focus();
        srchQuery(input.value.trim());
      });
    });
  }

  /* ---------------- Drawer mobile (header) ---------------- */
  function setMob(open) {
    const bg = document.querySelector('.acl-mob-bg');
    const panel = document.getElementById('acl-mob');
    if (!panel) return;
    panel.classList.toggle('on', open);
    if (bg) bg.classList.toggle('on', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    document.querySelectorAll('.acl-coll').forEach(initSlider);
    initReveal();
    initPcar();
    initRelated();
    initSearch();
    initBar();
    initVideo();
    // Na página do carrinho já adianta o link do checkout (redireciona instantâneo no clique).
    if (document.querySelector('[data-acl-cart][data-acl-cart-view="page"]')) cpPrewarm();
    document.addEventListener('click', function (e) {
      const pv = e.target.closest('[data-pcar-prev]');
      if (pv) { e.preventDefault(); pcarMove(pv, -1); return; }
      const nx = e.target.closest('[data-pcar-next]');
      if (nx) { e.preventDefault(); pcarMove(nx, 1); return; }
      const plus = e.target.closest('[data-acl-plus]');
      if (plus) { e.preventDefault(); sheetOpen(plus); return; }
      const sz = e.target.closest('[data-acl-sheet-add]');
      if (sz) { e.preventDefault(); sheetAdd(sz); return; }
      if (e.target.closest('[data-acl-sheet-close]')) { e.preventDefault(); sheetSet(false); return; }
      const add = e.target.closest('[data-acl-add]');
      if (add) { e.preventDefault(); quickAdd(add); return; }
      const cartLink = e.target.closest('#cart-icon-bubble');
      if (cartLink && cdMount()) { e.preventDefault(); cdOpen(); return; }
      const q = e.target.closest('[data-acl-qty]');
      if (q) { e.preventDefault(); cartChange(q); return; }
      if (e.target.closest('[data-acl-cd-close]')) { e.preventDefault(); cdSet(false); return; }
      if (e.target.closest('[data-acl-mob-open]')) { e.preventDefault(); setMob(true); return; }
      if (e.target.closest('[data-acl-mob-close]')) { e.preventDefault(); setMob(false); return; }
      if (e.target.closest('[data-acl-search-open]')) { e.preventDefault(); setMob(false); srchOpen(); return; }
      if (e.target.closest('[data-acl-search-close]')) { e.preventDefault(); srchClose(); return; }
      var ck = e.target.closest('[name="checkout"]');
      if (ck) { var fm = ck.closest('form'); if (cpGo(ck, fm)) { e.preventDefault(); return; } }
      var vT = e.target.closest('[data-acl-vid-toggle]');
      if (vT) { e.preventDefault(); vidToggle(vT); return; }
      var vS = e.target.closest('[data-acl-vid-sound]');
      if (vS) { e.preventDefault(); vidSound(vS); return; }
      var sClear = e.target.closest('[data-acl-search-clear]');
      if (sClear) {
        e.preventDefault();
        var si = document.querySelector('[data-acl-search-input]');
        if (si) { si.value = ''; si.focus(); srchQuery(''); }
        return;
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setMob(false); cdSet(false); sheetSet(false); srchClose(); } });

    // Um unico listener de scroll, throttled por rAF (evita layout thrash)
    var hdr = document.getElementById('acl-header');
    var ovl = document.querySelector('.acl-hdr--overlay');
    if (hdr || ovl) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          if (hdr) hdr.classList.toggle('scrolled', y > 8);
          if (ovl) ovl.classList.toggle('is-stuck', y > 40);
          revealSweep();
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Pausa marquees fora da viewport (para de repintar o tempo todo)
    var marquees = document.querySelectorAll('.acl-tick, .acl-mq');
    if (marquees.length && 'IntersectionObserver' in window) {
      var mo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('is-idle', !e.isIntersecting); });
      }, { rootMargin: '80px' });
      marquees.forEach(function (m) { mo.observe(m); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init no editor de temas (Customizer)
  document.addEventListener('shopify:section:load', boot);
})();
